import React from "react";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import PropTypes from "prop-types";
import Types from "../../constants/Types";
import APPCONFIG from "../../constants/Config";
import CollectionOverride from "components/CollectionOverride";
import {Link} from "react-router-dom";
import UniversalModalOverride from "../UniversalModalOverride";
import {Objects} from "../index";



export default class Forms extends CollectionOverride {
	static propTypes = {
		forForm: PropTypes.string.isRequired,
		...super.propTypes
	};

	constructor(props) {
		let model = new API.BuildClass(props.forForm, API.RequestType.READ_ALL);
		super(props, model);

		this.state.formP12 = false;
		this.state.p12_object = {};

	}

	async handleCombinedForms(props) {
		this.handlePrintFormClick(props);
		let url = `${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/filesizes/combined_form?location=${props.transaction_collections.location}&created=${props.created}`;
		window.open(url, "_blank");
	}

	handlePrintFormClick = (formObject) => {
		if (typeof this.props.onPrintFormClick === 'function') {
			this.props.onPrintFormClick(formObject);
		}
	}


	async handleEditP12(props) {
		await this.setState({p12_object: props.form_p12s});
		await this.setState({formP12: !this.state.formP12})
	}




	render() {

		const {data, pages, limit, loading} = this.state;
		const columns = [
			...[
				{
					Header: "Form",
					accessor: "forms.name",
					width: 130
				},
				{
					Header: "PDF",
					accessor: "forms.file",
					width: 160
				},
				{
					Header: "Description",
					className: "button-cell",
					filterable: false,
					sortable: false,
					// width: 400,

					Cell: props => props.original.forms.name === 'NY P12' ?
						<span onClick={() => this.handleEditP12(props.original)}>
							{props.original.forms.description} <div style={{color: "orange"}}>(Click me to edit) </div>
						</span> : props.original.forms.description

				},
			],
			...(this.props.forForm === Types.Manufactureds_Forms._name ? [
				{
					Header: "Year",
					accessor: "year",
				},
				{
					Header: "Quarter",
					accessor: "quarter",
				}
			] : []),
			...(this.props.forForm === Types.Transactions_Collections_Forms._name && !this.props.history.location.pathname.includes("acquisition") && !this.props.history.location.pathname.includes("transfer") ? [
				{
					Header: "Original ID",
					id: 'pkey',
					width: 100,
					accessor: obj => {
						if( obj.results ) {
							let results = JSON.parse(obj.results);
							if( results && results.id && obj.transaction && results.id !== obj.transaction ) {
								return results.id;
							}
						}
						return '';
					}
				},
				{
					Header: "Customer",
					id: 'customer',
					width: 230,
					accessor: obj => {
						return obj.customers ? (obj.customers.name_first + ' ' + obj.customers.name_last) : ''
					}
				},
				{
					Header: "Product",
					id: 'product',
					width: 220,
					accessor: obj => {
						return obj.products ? ((obj.products.id ? obj.products.id : (obj.products.binary_id + '-' + obj.products.pkey)) + ' (' + obj.products.serial_number + ')') : ''
					}
				},
				{
					Header: "Sent to CLEO",
					id: 'sent_cleo',
					width: 100,
					/** @param {Dispositions_Pendings_Forms_Object} obj */
					accessor: obj => {
						return obj.sent_cleo ? 'Sent' : ''
					}
				},
			] : []),
			...[
				{
					Header: "Date",
					id: "created",
					width: 160,
					/** @param {Dispositions_Pendings_Forms_Object} obj */
					accessor: obj => {
						return obj.created ? moment(obj.created).local().format("MM/DD/YYYY h:mm A") : '-'
					}
				},
				{
					Header: "",
					className: "button-cell",
					filterable: false,
					sortable: false,
					width: 200,
					Cell: props => {
						let url = this.props.url.replace('[PARENT]', this.props.parent);
						return (
							<span>
									{props.original.forms.file.includes('combined') ? <Button color="blue-hoki" size={"sm"} block={true} onClick={() => this.handleCombinedForms(props.original)}>
										<i className={"fa fa-cloud-download"}/> Print Form
									</Button> :<a href={`${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}${url}/${props.original._id}`}
									              onClick={() => this.handlePrintFormClick(props.original)}
									              target={'_blank'}> <Button color="blue-hoki" size={"sm"} block={true}>
										<i className={"fa fa-file-pdf-o"}/> Print Form
									</Button>
								</a>}
							</span>
						);
					}
				},
			]
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Forms', "")}
							{this.renderHeaderRight("Forms", columns)}

						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>


					<UniversalModalOverride
						locations={this.props.locations}
						states={this.props.states}
						name="Form P12"
						object={Objects.FormP12}
						history={this.props.history}
						toggle={this.state['formP12']}
						reportClose={this.reportClose('formP12')}
						afterSave={this.props.afterSave}
						url="dispositions"
						size="xl"
						objectProps ={{
							p12_object: this.state.p12_object,
							transaction_date: this.state.date,
							collection: this.props.id
						}}
						submitLabel={"Generate P12 Form"}

					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
